/**
 * External learning app — Courses page.
 * Local: http://localhost:5173/courses
 * Prod:  /courses  (nginx reverse-proxies to the learning container)
 */
export const LEARNING_URL =
  (process.env.REACT_APP_LEARNING_URL || '/courses').replace(/\/$/, '') || '/courses';

/** Full-page navigation into the learning Courses page. */
export function goToLearning() {
  window.location.assign(LEARNING_URL);
}

/** True when a path/URL targets the learning module. */
export function isLearningTarget(pathOrUrl) {
  if (!pathOrUrl) return false;
  const value = String(pathOrUrl);
  if (value === LEARNING_URL || value.startsWith(`${LEARNING_URL}/`)) return true;
  return (
    value === '/courses' ||
    value.startsWith('/courses/') ||
    value === '/learning' ||
    value.startsWith('/learning/')
  );
}
